import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { DEFAULT_PAGE_INDEX } from "@app/core/constants/pagination.const";
import { DEFAULT_SORT_DIRECTION } from "@app/core/constants/sort.const";
import { BaseHttpService } from "@app/core/services/base-http.service";
import { TResponse, TResponseFilter } from "@app/core/types/response.type";
import { TGlobalSearchRequest } from "@app/shared/request-type/global-search-request.interface";
import {
  IClaimSearchItem,
  TGlobalSearchResponse,
} from "@app/shared/response-type/global-search-response.interface";

const CLAIMS_URL = "claims";
const RELEVANCE_ORDER_COLUMN = "relevance";
const CLAIM_SCOPE_ALL = "All";
const CLAIM_SCOPE_MINE = "My";

@Injectable({ providedIn: "root" })
export class GlobalSearchApiService {
  private readonly http$ = inject(BaseHttpService);

  search(filter: TGlobalSearchRequest): Observable<TResponse<TGlobalSearchResponse>> {
    return this.http$.post('globalSearch/search', { filter });
  }

  searchClaims(
    term: string,
    pageSize: number,
    canViewAllClaims: boolean,
  ): Observable<TResponse<TResponseFilter<IClaimSearchItem>>> {
    return this.http$.post<TResponse<TResponseFilter<IClaimSearchItem>>>(`${CLAIMS_URL}/filter`, {
      page: DEFAULT_PAGE_INDEX,
      pageSize,
      orderColumn: RELEVANCE_ORDER_COLUMN,
      order: DEFAULT_SORT_DIRECTION,
      filters: {
        scope: canViewAllClaims ? CLAIM_SCOPE_ALL : CLAIM_SCOPE_MINE,
        searchMode: true,
        search: term,
      },
    });
  }
}
